export default "__VITE_ASSET__OIW2RFNr__"